// extracted by mini-css-extract-plugin
module.exports = {"alarm_modal_wrapper":"DetailModal_alarm_modal_wrapper__woT2g"};